import '.em{display:inline-flex;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.fe{padding:0 4px;}.ssr-plugin'
import '.ff{height:20px;}.ssr-plugin'
import '.fg{width:fit-content;}.ssr-plugin'
import '.fh{min-width:20px;}.ssr-plugin'
import { ReactNode } from 'react'
import { colors } from '../../tokens/colors.js'
import { radius } from '../../utils/radius.js'
import { Text } from '../Text/index.js'
import { styled, Style } from 'inlines'

type CounterProps = {
  children: ReactNode
  color?:
    | 'neutral'
    | 'inverted'
    | 'red'
    | 'green'
    | 'purple'
    | 'orange'
    | 'white'
  style?: Style
}

export const Counter = ({
  children,
  color = 'neutral',
  style,
}: CounterProps) => {
  return (
    <styled.div className="em c d fe ff fg fh"
      style={{
        borderRadius: radius.full,
        color:
          color === 'inverted'
            ? colors.neutral100
            : color === 'white'
              ? colors.black100
              : colors.neutralInverted100,
        background:
          color === 'inverted'
            ? colors.neutralInverted100
            : colors[`${color}100`],
        ...style,
      }}
    >
      <Text selectableText={false} color="inherit" variant="subtext-medium">
        {children}
      </Text>
    </styled.div>
  )
}

export type { CounterProps }
